import React from 'react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';
import { Button } from '../../ui/button';
import { Copy, FileCode2 } from 'lucide-react';
import { buildDbcBlock } from '../../../lib/canEndianness/dbc';
import SignalResultCard from './SignalResultCard';

const copyText = async (text, successMessage) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(successMessage);
  } catch {
    toast.error('Could not copy to clipboard.');
  }
};

const SignalResults = ({ signals, dataBytes, canIdDecimal, dlc, selectedSignalId, overlappingSignalIds, outOfRangeSignalIds, onSelect, onPhysicalEdit }) => {
  if (signals.length === 0) return null;

  return (
    <Card className="technical-card" data-testid="can-endianness-signal-results">
      <CardHeader className="flex flex-row items-center justify-between gap-2 flex-wrap">
        <div>
          <CardTitle className="font-chivo uppercase tracking-tight text-base flex items-center gap-2">
            <FileCode2 className="h-4 w-4 text-autoxium-blue" />
            Signal Details &amp; DBC Output
          </CardTitle>
          <CardDescription>Full field breakdown, physical/raw range, live conversion, and DBC definition for every signal.</CardDescription>
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => copyText(buildDbcBlock(canIdDecimal, dlc, signals), 'Full DBC message block copied to clipboard.')}
          data-testid="can-endianness-copy-all-dbc-btn"
        >
          <Copy className="h-3.5 w-3.5" /> Copy All (DBC)
        </Button>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          {signals.map((s, i) => (
            <SignalResultCard
              key={s.id}
              signal={s}
              index={i}
              dataBytes={dataBytes}
              isSelected={s.id === selectedSignalId}
              isOverlapping={overlappingSignalIds.has(s.id)}
              isOutOfRange={outOfRangeSignalIds.has(s.id)}
              onSelect={onSelect}
              onPhysicalEdit={onPhysicalEdit}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default SignalResults;
